export var BusinessTransactionStatus;
(function (BusinessTransactionStatus) {
    BusinessTransactionStatus["CANCELLED"] = "CANCELLED";
    BusinessTransactionStatus["SUCCESS"] = "SUCCESS";
    BusinessTransactionStatus["FAILED"] = "FAILED";
    BusinessTransactionStatus["PENDING"] = "PENDING";
    BusinessTransactionStatus["PROCESSING"] = "PROCESSING";
    BusinessTransactionStatus["REFUNDED"] = "REFUNDED";
    BusinessTransactionStatus["RETRY"] = "RETRY";
    BusinessTransactionStatus["UNKNOWN"] = "UNKNOWN";
    BusinessTransactionStatus["SCHEDULED"] = "SCHEDULED";
    // This is a status used to identify transactions that require customer action
    // It should be used when the transaction is pending and the customer needs to take action
    // to complete the transaction
    BusinessTransactionStatus["CUSTOMER_ACTION_REQUIRED"] = "CUSTOMER_ACTION_REQUIRED";
    BusinessTransactionStatus["CHECKER_APPROVAL_REQUIRED"] = "CHECKER_APPROVAL_REQUIRED";
    BusinessTransactionStatus["REJECTED"] = "REJECTED";
    BusinessTransactionStatus["IN_REVIEW"] = "IN_REVIEW";
    BusinessTransactionStatus["ENGINEERING_REVIEW_REQUIRED"] = "ENGINEERING_REVIEW_REQUIRED";
    // Set when a payout is placed on hold by the processor pending a request for
    // information (RFI). Non-terminal: not retried, and it does not fire a
    // terminal webhook while on hold, but it stays in the processing-poll loop so
    // a later processor-side transition is still picked up. The upfront ledger
    // debit stays in place (counted as in-transit) until it resolves. dlocal maps
    // its ON_HOLD payout status to this.
    BusinessTransactionStatus["RFI_REQUESTED"] = "RFI_REQUESTED";
    BusinessTransactionStatus["DISPUTED"] = "DISPUTED";
    BusinessTransactionStatus["DISPUTE_RESOLVED"] = "DISPUTE_RESOLVED";
    BusinessTransactionStatus["DISPUTE_WON"] = "DISPUTE_WON";
    BusinessTransactionStatus["DISPUTE_LOST"] = "DISPUTE_LOST";
    BusinessTransactionStatus["DISPUTE_EVIDENCE_SUBMITTED"] = "DISPUTE_EVIDENCE_SUBMITTED";
})(BusinessTransactionStatus || (BusinessTransactionStatus = {}));
//# sourceMappingURL=BusinessTransactionStatus.js.map